import css from 'styled-jsx/css';
import { icons } from '../../config/styles';
import { svgToDataUri } from '../../utils/styles/svgMixins';

const ServicesPricesStyle = css`
  .services-prices-section {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }
  .cmr-icon {
    display: flex;
    height: 16px;
    min-width: 33px;
    background-image: url('${svgToDataUri(icons.oportunidadUnica)}');
    background-size: 100%;
    background-position: center;
  }
  .price {
    display: flex;
    gap: 4px;
    .cmrPrice {
      color: #e40046;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
    }
    .internetPrice,
    .eventPrice {
      color: #333;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
    }
    .normalPrice {
      color: #717171;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      text-decoration-line: line-through;
    }
  }
`;

export default ServicesPricesStyle;
